var _g, _circle, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlacemarkSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 82,
    viewBox: "0 0 63 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5505_4681)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5008 0C14.1191 0 0 14.2533 0 31.7513C0 43.7688 5.31245 49.6775 11.4654 55.3993C17.6183 61.1212 25.3231 66.9538 30.4254 80.3174C30.705 81.0236 31.08 81.06 31.4859 81.4866C31.92 81.06 32.2668 81.0236 32.5464 80.3174C37.6504 66.9538 45.3536 61.1162 51.5065 55.3993C57.6594 49.6824 63 43.7721 63 31.7513C63 14.2566 48.8891 0 31.4992 0H31.5008ZM31.5008 21.0683C33.6997 21.0683 35.8493 21.72 37.6776 22.9412C39.506 24.1623 40.931 25.8979 41.7725 27.9285C42.614 29.9591 42.8341 32.1936 42.4051 34.3492C41.9762 36.5049 40.9173 38.4851 39.3624 40.0393C37.8075 41.5934 35.8265 42.6518 33.6698 43.0806C31.5132 43.5094 29.2777 43.2893 27.2462 42.4482C25.2146 41.6071 23.4783 40.1828 22.2566 38.3552C21.0349 36.5277 20.3829 34.3792 20.3829 32.1812C20.3899 29.236 21.5635 26.4135 23.647 24.3309C25.7305 22.2483 28.5543 21.0753 31.5008 21.0683Z",
    fill: "#487A7B"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.58,
    cy: 31.58,
    r: 20.58,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5505_4681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4477 24.7292L31 24.3594L30.5523 24.7292C28.6075 26.3353 27.4844 29.2875 27.4844 31.8C27.4844 34.326 28.6026 36.6981 30.5523 38.3083L31 38.6782L31.4477 38.3083C33.3974 36.6981 34.5156 34.326 34.5156 31.8C34.5156 29.2878 33.3928 26.3354 31.4477 24.7292Z",
    fill: "#487A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7319 37.261C26.6458 35.6592 26.0781 33.8082 26.0781 31.8001C26.0781 29.6364 26.6443 27.8939 27.3663 26.5519C25.947 25.4941 24.7037 25.2378 24.372 25.106C24.3117 25.2979 21.9561 28.5628 23.6262 32.7944C24.384 34.7148 25.8092 36.3166 27.7319 37.261Z",
    fill: "#487A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2676 37.2592C36.1904 36.3151 37.6158 34.7148 38.3737 32.7944C40.0455 28.5588 37.6904 25.3048 37.6279 25.106C37.3027 25.235 36.0492 25.4951 34.6309 26.5543C35.3536 27.8969 35.9218 29.6396 35.9218 31.8001C35.9218 33.8302 35.3395 35.6772 34.2676 37.2592Z",
    fill: "#487A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3179 33.3109C22.1688 32.9326 22.0436 32.5483 21.9432 32.1606C20.2947 32.4179 19.3184 33.0388 19 33.1721C19.1031 33.3631 19.7507 37.1587 23.851 38.9387C25.5691 39.6839 27.5342 39.8485 29.3936 39.3212C26.0767 38.5796 23.5108 36.3338 22.3179 33.3109Z",
    fill: "#487A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0566 32.1606C39.9563 32.5486 39.8311 32.9326 39.682 33.3109C38.49 36.3311 35.9311 38.5745 32.6021 39.3208C34.4371 39.8416 36.4066 39.6949 38.1489 38.9387C42.2349 37.1649 42.901 33.3549 42.9999 33.1721C42.6794 33.0381 41.7057 32.4181 40.0566 32.1606Z",
    fill: "#487A7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5505_4681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 81.48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5505_4681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(19 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacemarkSpa);
export default __webpack_public_path__ + "static/media/placemark-spa.465cebddd793803b6270ba5e64bcf94e.svg";
export { ForwardRef as ReactComponent };